//export const KEYCLOACK_URL=process.env.KEYCLOACK_URL
//export const KEYCLOACK_BODY=process.env.KEYCLOACK_BODY

//HOMOLOCAGAO
export const KEYCLOACK_URL="https://keycloak-hom.fazenda.mg.gov.br/realms/distvaf/protocol/openid-connect/token"
export const KEYCLOACK_BODY = "grant_type=client_credentials&client_id=backend&client_secret=3w9RQfSrrS4temlXhm6QFNCoSOjplxwy"


//PRODUCAO
//export const KEYCLOACK_URL="https://acesso.fazenda.mg.gov.br/realms/intranet/protocol/openid-connect/token"
//export const KEYCLOACK_BODY = "grant_type=client_credentials&client_id=distvaf-backend&client_secret=XeGwWzPDPSPhPOrA1SoCXeNPMQhzdhuF"